// @flow
import React from 'react';
import printIcon from './print.svg';
import logo from './logo.png';
import './styles.css';

type Props = {
  displayPrintButton?: boolean
};

function print(): void {
  window.print();
}

export default function Header({ displayPrintButton }: Props) {
  return (
    <header className="Header">
      <h2 className="Header__title">Simulador de Préstamos</h2>
      <p className="Header__subtitle">Asociación Mutual 9 de Julio Olímpico de Freyre</p>
      <img
        src={logo}
        className="Header__logo"
        alt="Logo Asociación Mutual 9 de Julio Olímpico de Freyre" />

      {
        displayPrintButton && (
          <button className="Header__print-button" onClick={print}>
            <figure className="Header__print-button__figure">
              <img className="Header__print-button__figure-icon" src={printIcon} alt="" title="Imprimir detalles del préstamo" />
              <figcaption className="Header__print-button__figure-caption">Imprimir Detalles</figcaption>
            </figure>
          </button>
        )
      }
    </header>
  );
}
